import { render, staticRenderFns } from "./LeagueStats.vue?vue&type=template&id=7044e6d7&scoped=true"
import script from "./LeagueStats.vue?vue&type=script&lang=js"
export * from "./LeagueStats.vue?vue&type=script&lang=js"
import style0 from "./LeagueStats.vue?vue&type=style&index=0&id=7044e6d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7044e6d7",
  null
  
)

export default component.exports